export const GET_GOOGLE_MAPS_LIBRARIES = 'GET_GOOGLE_MAPS_LIBRARIES'
export const GET_GEOCODE_OF_SEARCH_QUERY = 'GET_GEOCODE_OF_SEARCH_QUERY'
export const UPDATE_GEOCODER = 'UPDATE_GEOCODER'
export const UPDATE_LAST_GEOCODE_RESULT = 'UPDATE_LAST_GEOCODE_RESULT'
